module.exports = __webpack_public_path__ + "img/2.22c7b821.png";